import React from 'react';
import PropTypes from 'prop-types';

import SelectPicker from 'components/SelectPicker/SelectPicker';
import LockChangeLabel from './LockChangeLabel';
import { TimeframeFetcher } from '../utils/timeFrameFetcher';
import { apiFetch } from '../utils';

/**
 * Track silo selector. This is primarily used on contact list pages and setup pages.
 */
const SchoolYearSelect = ({
  onSelect, schoolYears, schoolYearId, standardButton, withDefaultTerms, timeframeFetcher, onLockToggle, disabled
}) => {
  if (schoolYears.length <= 0) {
    return '';
  }

  const defaultYearsOptions = [
    { id: 'all-terms', name: 'All Terms' },
    { id: 'no-term', name: 'No Term' }
  ];

  let availableTerms = schoolYears;
  if (withDefaultTerms) {
    availableTerms = defaultYearsOptions.concat(schoolYears);
  }

  let selectedSchoolYearId = schoolYearId;
  if (selectedSchoolYearId === null || selectedSchoolYearId.trim() === '') {
    selectedSchoolYearId = 'all-terms';
  }

  return (
    <div className='track-silo'>
      <SelectPicker
        value={selectedSchoolYearId}
        onChange={onSelect}
        options={
          availableTerms.map((sy) => ({
            value: sy.id,
            label: sy.name
          }))
        }
        standardButton={standardButton}
        disabled={disabled}
      />
      {!!onLockToggle && (
        <LockChangeLabel
          schoolYearId={schoolYearId}
          schoolYearType='enrollment'
          timeframeFetcher={timeframeFetcher}
          onLockToggle={onLockToggle}
        />
      )}
    </div>
  );
};

SchoolYearSelect.propTypes = {
  /** ID of the currently selected school year */
  schoolYearId: PropTypes.string,

  /** All available school years */
  schoolYears: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  })),

  /** Called upon selection of a new school year. */
  onSelect: PropTypes.func,

  /** Set to true to make this the same size as other buttons */
  standardButton: PropTypes.bool,

  /** Check whether "no term" and "all terms" options are included for the selections */
  withDefaultTerms: PropTypes.bool,

  timeframeFetcher: PropTypes.objectOf(TimeframeFetcher),

  onLockToggle: PropTypes.oneOfType([PropTypes.func, PropTypes.bool])
};

SchoolYearSelect.defaultProps = {
  schoolYears: [],
  schoolYearId: '',
  standardButton: false,
  withDefaultTerms: false,

  onSelect: () => false,
  timeframeFetcher: (new TimeframeFetcher(apiFetch)),
  onLockToggle: false // Don't show lock stuff if they don't pass a function for it
};

export default SchoolYearSelect;
